module.exports = ` 2.5.5-rc`.trim();



// WEBPACK FOOTER //
// ./src/const-branch-name.js